import * as _ from 'lodash';
import type * as React from 'react';

import type { AsyncValue } from '../../redux/asyncValue';

export type LoadingBoundaryProps<T> = {
  /** The Async value to watch */
  asyncValue: AsyncValue<T>;
  /** Renders when the value is resolved */
  renderValue: (props: {value: T}) => React.JSX.Element;
  /** Renders when the value has errors */
  renderError: (props: {errors: string[]}) => React.JSX.Element;
  /** Renders when the value is loading */
  renderLoading: React.JSX.Element;
  /** Renders when the value is empty */
  renderEmpty: React.JSX.Element;
};

/**
 * A component that branches rendering depending on the status of an AsyncValue.
 */
export function LoadingBoundary<T>({
  asyncValue,
  renderValue,
  renderError,
  renderLoading,
  renderEmpty,
}: LoadingBoundaryProps<T>) {
  if (asyncValue.isLoading) {
    return renderLoading;
  }

  if (asyncValue.errors !== null && !_.isEmpty(asyncValue.errors)) {
    return renderError({ errors: asyncValue.errors });
  }

  if (asyncValue.value) {
    return renderValue({ value: asyncValue.value });
  }

  return renderEmpty;
}
